import { render, staticRenderFns } from "./EventShift.vue?vue&type=template&id=1ef78cf4&"
import script from "./EventShift.vue?vue&type=script&lang=js&"
export * from "./EventShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports